import { DollarOutlined, FileTextOutlined, GlobalOutlined, HomeOutlined, MailOutlined, PhoneOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Badge, Button, Card, Col, Divider, Row, Space, Statistic, Tag, Typography } from 'antd'
import React, { useState } from 'react'
import { displayNumbers } from '../../../variables/numbersFunctions'
import EditMembreModal from './EditMembreModal';

const { Title, Text } = Typography;


const ProfilingMembre = ({ membre, globalStats, colors, logo }) => {
    const [visible, setVisible] = useState(false);
    const [exercices, setExercices] = useState([]);

    const handleCancel = () => {
        setVisible(false);
    };
    return (
        <Col xs={24} lg={8}>
            <Card
                bordered={false}
                style={{ borderRadius: '12px', height: '100%' }}
            >
                {/* Avatar et infos principales */}
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    {logo ? (
                        <div
                            style={{
                                display: 'inline-flex',
                                margin: '0 auto 16px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                maxWidth: 220,
                                maxHeight: 140
                            }}
                        >
                            <img
                                src={logo}
                                alt="Logo du membre"
                                style={{
                                    width: 'auto',
                                    height: 'auto',
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    ) : (
                        <Avatar
                            shape="square"
                            size={100}
                            style={{
                                backgroundColor: colors.primary,
                                marginBottom: '16px'
                            }}
                        >
                            <Text style={{ fontSize: '32px', color: 'white' }}>
                                {membre?.raisonSociale?.charAt(0)}
                            </Text>
                        </Avatar>
                    )}
                    <Title level={4} style={{ marginBottom: '4px', color: colors?.primary }}>
                        {membre?.raisonSociale}
                    </Title>
                    <Text type="secondary">Code #{membre?.code}</Text>
                    <div style={{ marginTop: '12px' }}>
                        <Badge
                            status={membre?.active ? "success" : "error"}
                            text={membre?.active ? "Actif" : "Inactif"}
                            style={{ fontSize: '14px' }}
                        />
                    </div>
                </div>

                <Divider />

                {/* Statistiques rapides */}
                <Row gutter={16} style={{ marginBottom: '24px' }}>
                    <Col span={12}>
                        <Card
                            size="small"
                            style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '8px',
                                border: 'none'
                            }}
                        >
                            <Statistic
                                title={<Text style={{ color: 'rgba(255,255,255,0.9)' }}>Contrats</Text>}
                                value={globalStats?.totalContratsExerciceCourant}
                                valueStyle={{ color: 'white', fontSize: '24px' }}
                                prefix={<FileTextOutlined />}
                            />
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card
                            size="small"
                            style={{
                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                borderRadius: '8px',
                                border: 'none'
                            }}
                        >
                            <Statistic
                                title={<Text style={{ color: 'rgba(255,255,255,0.9)' }}>Production</Text>}
                                value={displayNumbers(globalStats?.totalProductionExerciceCourant / 1000000)}
                                valueStyle={{ color: 'white', fontSize: '20px' }}
                                suffix={<Text style={{ color: 'white', fontSize: '14px' }}>M</Text>}
                                prefix={<DollarOutlined />}
                            />
                        </Card>
                    </Col>
                </Row>

                <Divider>Détails</Divider>

                {/* Informations détaillées */}
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <UserOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            RESPONSABLE
                        </Text>
                        <br />
                        <Text strong>{membre?.responsable}</Text>
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <MailOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            EMAIL
                        </Text>
                        <br />
                        <Text strong>{membre?.email}</Text>
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <PhoneOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            CONTACTS
                        </Text>
                        <br />
                        <Text strong>{membre?.contact ? membre?.contact[0] : membre?.telephone1 || "--"}</Text>
                        {membre?.contact?.length > 1 && membre?.contact[1] ? (
                            <>
                                <br />
                                <Text strong>{membre?.contact[1] || "--"}</Text>
                            </>
                        ) : <>
                            <br />
                            <Text strong>{membre?.telephone2 || "--"}</Text>
                        </>}
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <HomeOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            SIÈGE SOCIAL
                        </Text>
                        <br />
                        <Text strong>{membre.siegeSocial}</Text>
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <GlobalOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            SITE WEB
                        </Text>
                        <br />
                        <Text strong>{membre.website}</Text>
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <SafetyOutlined style={{ marginRight: '8px', color: colors.primary }} />
                            DOUBLE AUTHENTIFICATION
                        </Text>
                        <br />
                        <Tag color={colors.primary}>{membre?.otpConnexion}</Tag>
                    </div>

                    <div>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            EXERCICE PAR DÉFAUT
                        </Text>
                        <br />
                        <Tag color="blue">{membre?.defaultExercice?.libelleExercice}</Tag>
                    </div>
                </Space>

                <Divider />

                <Button
                    type="primary"
                    block
                    size="large"
                    style={{
                        backgroundColor: colors.primary,
                        borderColor: colors.primary,
                        borderRadius: '8px',
                        height: '48px'
                    }}
                    onClick={() => setVisible(true)}
                >
                    Éditer les informations
                </Button>
            </Card>
            <EditMembreModal membreData={membre} visible={visible} onCancel={handleCancel} exercices={exercices} />
        </Col>
    )
}

export default ProfilingMembre
